import { lazy } from "react";
import Loadable from "../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../router/AuthorizedRoute";
import {
  ACCOUNT_RECEIVABLE
} from "./AccountReceivable.constants";
const TestOne = Loadable(
  lazy(() =>
    import("./AccountReceivable").then(({ AccountReceivableTab }) => ({
      default: AccountReceivableTab,
    }))
  )
);


export const accountReceivableReports = [
  {
    path: `${ACCOUNT_RECEIVABLE}`,
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleKeys={[]}>
        <TestOne />
      </AuthorizedRoute>
    ),
  },
  
];
